import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const partners = [
  { name: "Rane", subtitle: "Expanding Horizons", logo: "/brand/rane-logo.png", href: "https://ranegroup.com/" },
  { name: "Mpover", subtitle: "Premium Tyre Mounting Paste", text: true, href: null },
  { name: "AMK Herbals & Spices", subtitle: "We Bring Fragrance to Life", logo: "/partners/amk.png", href: null },
];

export default function Partners() {
  const { t } = useLang();
  return (
    <section
      data-testid="partners-section"
      className="relative py-20 md:py-28 bg-white border-y border-[#D5DEE8]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="text-center mb-12 md:mb-14">
          <p className="overline-maroon mb-4">{t("partners.overline")}</p>
          <h2 className="font-serif-display font-light text-3xl md:text-5xl tracking-tight text-[#0F1E33]">
            {t("partners.title1")} <span className="italic text-[#1E3A5F]">{t("partners.titleItalic")}</span>
          </h2>
          <div className="mx-auto mt-6 w-24 hairline-gold" />
          <p className="mt-6 max-w-2xl mx-auto text-[#1F2D40] text-lg md:text-xl leading-relaxed">
            {t("partners.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {partners.map((p, idx) => {
            const Wrap = p.href ? "a" : "div";
            const props = p.href ? { href: p.href, target: "_blank", rel: "noreferrer" } : {};
            return (
              <motion.div
                key={p.name}
                data-testid={`partner-${p.name.toLowerCase()}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
              >
                <Wrap
                  {...props}
                  className="block aspect-[4/3] bg-white border border-[#D5DEE8] hover:border-[#B8860B] transition-colors p-6 md:p-8 flex flex-col items-center justify-center text-center shadow-sm"
                >
                  {p.logo ? (
                    <img
                      src={p.logo}
                      alt={p.name}
                      className="h-20 md:h-24 w-auto object-contain mb-3"
                    />
                  ) : (
                    <div className="font-[Outfit] font-bold text-3xl md:text-4xl tracking-tight text-[#E65100]">
                      {p.name}
                    </div>
                  )}
                  <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#4A5A70] mt-2">
                    {p.subtitle}
                  </div>
                </Wrap>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
